// hooks/useBitKeepDetection.ts
import { useState, useEffect } from 'react';

export const useBitKeepDetection = () => {
  const [isBitKeep, setIsBitKeep] = useState(false);

  useEffect(() => {
    // 确保代码只在客户端执行
    if (typeof window !== 'undefined') {
      const isDetected = /(BitKeep)/i.test(window.navigator.userAgent);
      setIsBitKeep(isDetected);
    }
  }, []);

  return isBitKeep;
};
